/**
 * The booking-engine notification currently on screen. These are sticky and mostly
 * non-closable, so a repeat replaces its predecessor instead of stacking copies the
 * subscriber cannot dismiss, and a new action or page drops it rather than carrying it over.
 */
export function useBookingEngineErrorNotification() {
  const activeId = useState<string | null>('bookingEngineErrorNotification', () => null);

  function clear() {
    if (activeId.value) useNotificationsStore().remove(activeId.value);
    activeId.value = null;
  }

  return { activeId, clear };
}
